import { FilterItem, keyPair, IncidentStatus } from "@repo/models";
import { useMemo } from "react";

import { useRepIncidentQueries } from "../../api/repIncidentApi";

interface incidentLists {
	customerContacts: keyPair<string>[];
	callAttempts: keyPair<string>[];
	loaStatuses: keyPair<string>[];
	statuses: keyPair<string>[];
	complaintActions: FilterItem[];
	users: FilterItem[];
}

export function useIncidentLists() {
	const { useComplaintActionsQuery, useUsersQuery } = useRepIncidentQueries();
	const { data: complaintActions, loaded: complaintActionsLoaded } = useComplaintActionsQuery();
	const { data: users, loaded: usersLoaded } = useUsersQuery();

	const incidentLists = useMemo<incidentLists>(() => {
		return {
			customerContacts: [
				{ id: 1, value: "Spoke with Customer" },
				{ id: 2, value: "Left Voice Message" },
				{ id: 3, value: "Unable to Contact" },
				{ id: 4, value: "Bad Number" },
				{ id: 5, value: "Agent Phone Number" },
				{ id: 6, value: "Not Applicable" },
				{ id: 7, value: "Customer Declined Contact" },
			],
			callAttempts: [
				{ id: 1, value: "1st Attempt" },
				{ id: 2, value: "2nd Attempt" },
				{ id: 3, value: "3rd Attempt" },
			],
			loaStatuses: [
				{ id: 1, value: "LOA - Signature" },
				{ id: 2, value: "LOA - No Signature" },
				{ id: 3, value: "Missing LOA" },
				{ id: 4, value: "No LOA - Contactless" },
				{ id: 5, value: "No LOA - Reactive" },
				{ id: 6, value: "No LOA - DXC" },
				{ id: 7, value: "No LOA - Non-Customer" },
			],
			statuses: Object.entries(IncidentStatus)
				.filter((e) => typeof e[1] !== "string")
				.map((e) => {
					return { id: e[1] as number, value: e[0] };
				}),
			complaintActions: complaintActions?.data ?? [],
			users: users?.data ?? [],
		};
	}, [complaintActions?.data, users?.data]);

	const allLoaded = complaintActionsLoaded && usersLoaded;

	return [incidentLists, allLoaded] as [incidentLists, boolean];
}
